<template>
	<div id="leading-enterprises" class=""> 
	<!-- 投资大脑的多个智能推荐页面 -->
	<leftnav class="fl" mkcode="C" :itemcode="pagecode"></leftnav> 
		<div class="bluebanner"> 
			<div class="centerpage1">
				<h2 class="title">龙头企业招商(智能推荐)</h2>
				<p>就是给政府匹配有招商潜力的大企业</p>
			</div>
		</div>
		<div class="index_left" :style="isCollapse?'margin-left: 0;width:100%':''"> 
			<el-dialog class="localChain" title="" :visible.sync="isShowFreeUserTips" width="650px" top="20vh">
				<freeUserTips :type="4" :bgtype="0"></freeUserTips>
			</el-dialog>
		<govheader ></govheader>
			<!-- <span   @click="isCollapse = !isCollapse"  v-html="isCollapse?'>':'<'" class="nav_btn"> 展开</span> -->
			<div class="index_left_centerpage">  
				<div class="right_topbox_recomd"  >
					<div class="right_boxtitle">
						<!-- <span :class="searchtype==9?'recomd_title recomd_title_activ':'recomd_title'" @click="searchtype=9;ajaxsearchcompany()">上市企业</span> 
						<span :class="searchtype==1?'recomd_title recomd_title_activ':'recomd_title'" @click="searchtype=1;ajaxsearchcompany()">龙头企业</span> 
						<span :class="searchtype==2?'recomd_title recomd_title_activ':'recomd_title'" @click="searchtype=2;ajaxsearchcompany()">创新企业</span>
						<span :class="searchtype==3?'recomd_title recomd_title_activ':'recomd_title'" @click="searchtype=3;ajaxsearchcompany()">优质企业</span> -->
						<span v-for="(item,index) in enterinarr" @click="typetoggle(item);" :class="searchtype == item.type?'recomd_title recomd_title_activ':'recomd_title'">{{item.name}}</span>
						<span class="recommend-tips"><i class="el-icon-star-on"></i>自动推荐关注产业的企业和机构</span>
						<div class="fr search-box nz-search-box">
							<span class="searchtype">企业库</span>
							<input type="text" placeholder="请输入企业名称" class="search-input" v-model="searchtext"	@keydown="searchenter" v-show="searchtype==2" />
							<input type="text" placeholder="请输入企业名称" class="search-input" v-model="searchtext"	@keydown="searchenter" v-show="searchtype==3"/>
							<input type="text" placeholder="请输入投资机构名称" class="search-input" v-model="searchtext"	@keydown="searchenter" v-show="searchtype==6"/>
							<input type="text" placeholder="请输入科研机构名称" class="search-input" v-model="searchtext"	@keydown="searchenter" v-show="searchtype==7" />
							<button class="search-btn" @click="searchkwfun">查询</button>
						</div> 
					</div> 
				</div> 
				
			<div class="whitebox "  >
			<div class="recommend-searchtext">
				 <span class="chanyeshezhi" @click="routerlinkid('/userFocus')">产业设置</span>
			</div>
				<listMenu v-if="cityflag" :searchtype="searchtype" :selectcitydata="selectcitydata" :total="total" :total1="total1" :citymapdata="citymapdata" texts="企业" v-on:chartmapclick="chartmapclick" :notionlist="notionlist"   v-on:notionclickfun="notionclickfun" v-on:choosecityide="choosecityide"></listMenu> 
				<div class="enterprise_list_box" v-show="enterpristlist.length!=0">
					<div class="enterparise_guide" style="line-height: 10px;height: 34px;padding-left: 47px;">
						<p class="fl" v-if="!kwtextsearch">产业大脑为您找到<span class="searchnum">{{total}}</span>条匹配的企业</p>
						<p class="fl" v-if="kwtextsearch">产业大脑为您找到<span class="searchnum">{{total}}</span>条【 <span class="orangefont">{{kwtextsearchtext}}</span>】相关企业</p> 
					</div> 
				<!-- 龙头企业 和 优质企业 上市公司 -->
					<table border="0" cellspacing="0" cellpadding="0" class="enterprise_table" v-show="searchtype==1 || searchtype == 3 || searchtype == 9"> 
						<tr><th>企业名称</th><th>所属产业</th><th>画像标签</th><th>地区</th><th>投资数</th><th>员工人数</th></tr> 
						<tr v-for="list in enterpristlist">
							<td class="title"  @click="routerlinkid('/enterprises',list.stockCode,1,'','leading')">{{list.title}}</td>
							<td class="conpanytags hastag">
								<span class="span-tag" v-for="item in list.notionlist" @click="tagrouter('/enterpriseTag',searchtype,'notion',item.id,item.name,'recommend')">{{item.name}}</span> 
							</td>
							<td class="conpanytags hastag"> 
								<span class="span-tag" v-for="item in list.taglist"@click="tagrouter('/enterpriseTag',searchtype,'tag',item.id,item.name,'recommend')">{{item.name}}</span> 
							</td>
							<td>{{list.area}}</td>     
							<td v-html="list.invest == 50?'50+':list.invest"></td>  
							<td>{{list.insurePerson}}</td>  
						</tr>
					</table>
					<!-- 创新企业 -->
					<table border="0" cellspacing="0" cellpadding="0" class="enterprise_table" v-if="searchtype == 2" >
						<tr>
							<th>企业名称</th>
							<th>所属产业</th>
							<th>画像标签</th> 
							<th>星级</th> 
							<th>融资轮次</th>
							<th>融资时间</th>
							<th>融资金额</th>
							<th>地区</th>
							<th>投资方</th>  
							</tr> 
						<tr v-for="list in enterpristlist" >
							<td class="title"  @click="routerlinkid('/enterprises',list.stockCode,2,'','leading')">{{list.title}}</td>
							<td class="conpanytags hastag1" v-show="list.notion!=''">
									<span class="span-tag" v-for="item in list.notionlist"  :title="item.name"  @click="tagrouter('/enterpriseTag',searchtype,'notion',item.id,item.name,'recommend')">{{item.name}}</span> 
							</td> 
							<td class="conpanytags" v-show="list.notion==''" style="width: 100px;">
								<div class="" style="color: #999;">-</div>
							</td> 
							<td class="conpanytags hastag1" v-show="list.tag!=''"> 
									<span class="span-tag" v-for="item in list.taglist"   @click="tagrouter('/enterpriseTag',searchtype,'tag',item.id,item.name,'recommend')">{{item.name}}</span> 
							</td> 
							<td class="conpanytags" v-show="list.tag==''" style="width: 100px;">
								<div class="" style="color: #999;">-</div>
							</td> 
							<td>
								<p class="stargrade" v-if="typeof(list.star) == 'number' && list.star > 0">
									<img src="@/assets/starfull.png" alt="" v-for="(item,i) in list.star" >
									<img src="@/assets/star.png" alt="" v-for="(item,i) in (5-list.star)" >
								</p>
								<span v-if="list.star == 0">-</span>
							</td> 
							<td  v-html="list.financingRound.length>0?list.financingRound[0].rount:'-'"></td> 
							<td  v-html="list.financingRound.length>0?list.financingRound[0].time:'-'"></td> 
							<td  v-html="list.financingRound.length>0?list.financingRound[0].amount:'-'"></td>  
							<td>{{list.area}}</td>
							<td class="orglist" >
								<p v-if="list.financingRound.length>0"><span v-for="(org,inds) in list.financingRound[0].orgList" data="org.id" :class="org.id!=0?'curp':''" @click="routerlinkid('/investement-enterprises',org.id)">
								{{org.orgName}}<i v-if="inds!=list.financingRound[0].orgList.length-1">、</i></span></p>
								<p v-if="list.financingRound.length==0">-</p>
								</td>  
						</tr>
					</table>  
					<!-- 科研机构 -->
					<table border="0" cellspacing="0" cellpadding="0" class="enterprise_table" v-if="searchtype == 7">
						<tr>
							<th>企业名称 </th>
							<th>地区</th>
							<th>员工人数</th>
							<!-- <th>级别</th>  
							<th>类别</th>  -->
							<th>研究领域</th>
						</tr>
						<tr v-for="list in enterpristlist" >
							<td class="title" @click="detailrouterto('/resources-enterprises',list.id)">{{list.title}}</td>
							<td>{{list.area}}</td>
							<td>{{list.insurePerson}}</td>
							<!-- 	<td>{{list.area}}</td>
							<td>{{list.area}}</td> -->
							<td :class="list.notion == ''?'conpanytags':'conpanytags hastag'">
								<span class="span-tag" v-for="item in list.notionlist"  @click="tagrouter('/enterpriseTag',searchtype,'notion',item.id,item.name)">{{item.name}}</span>
								<i v-show="list.notionlist.length==0" style="color:#999">-</i>
							</td> 
						</tr>
					</table>
					<!-- 投资机构 -->
					<table border="0" cellspacing="0" cellpadding="0" class="enterprise_table" v-if="searchtype==6">
						<tr> 
							<th>企业名称 </th>
							<th>投资领域</th>
							<th>画像标签</th>
							<th>项目数</th>
							<th>进入下一轮项目数</th> 
							<!-- <th>投资阶段</th> -->
							<th>机构类型</th> 
							<th>地区</th> 
							<th>管理规模 </th>  
						</tr>
						<tr v-for="list in enterpristlist" " >
							<td class="title" @click="detailrouterto('/investement-enterprises',list.id)">{{list.name}}</td>
							<td class="conpanytags hastag">
								<span class="span-tag" v-for="(item,i) in list.notionlist"  @click="tagrouter('/enterpriseTag',searchtype,'notion',item.id,item.name)">{{item.name}}</span>
								<i v-show="list.notion == ''">-</i>
							</td>
							<td class="conpanytags hastag">
								<span class="span-tag" v-for="item in list.taglist"   @click="tagrouter('/enterpriseTag',searchtype,'tag',item.id,item.name)">{{item.name}}</span>
								<i v-show="list.tag == ''">-</i>
							</td>
							<td>{{list.projectCount}}</td> 
							<td>{{list.nextRound}}</td>
							<!-- <td>{{list.stage}}</td> -->
							<td>{{list.type}}</td> 
							<td>{{list.area}}</td> 
							<td>
								<span v-if="list.asset != ''">{{list.asset}}</span>
								<span v-if="list.asset == ''">-</span> 
							</td>  
						</tr>
					</table>
				</div>
				<div class="centerpage1 company_pagelist" v-show="totalPage>1">
					<zpagenav v-bind:page="page" v-bind:page-size="pageSize" v-bind:total="total" 	v-bind:max-page="maxPage"  v-on:pagehandler="pageHandler">
					</zpagenav>
				</div>
			</div>   
			
			</div>  
			</div> 
	</div>
</template> 
<script>  
// import {PCC} from "../../assets/js/city.js";
import $ from "jquery";
import { mapState, mapMutations, mapGetters } from "vuex";

	export default {
		name: 'intelligentRecommendation',
		computed: {
		...mapState({
			isCollapse: (state) => state.isCollapse,
		}),
		...mapGetters(['isCollapse'])
	},
		data() {
			return {  
				isShowFreeUserTips:false,//免费用户提示
				title:"产业链招商线索",
				pagecode:'C-CXQYTJ',
				enterinarr: [ 
					{curindex: 1,type: 2,name: "创新企业",tagnum:3,pagecode:'C-CXQYTJ'}, 
					{curindex: 2,type: 3,name: "优质企业",tagnum:10009,pagecode:'C-YZQYTJ'},
					{curindex: 3,type: 6,name: "投资机构",tagnum:10010,pagecode:'C-ZYJGTJ'},
					{curindex: 4,type: 7,name: "科研机构",tagnum:10010,pagecode:'C-KYJGTJ'},
					// {curindex: 3,type: 0,name: "全部企业",tagnum:0,}, 
					],
				notionslide:false,//分类导航
				notionslide1:false,//城市选择
				notionslide3:false,//城市地图
				showmorecitydata:false,//显示更多城市选择
				notioneditbtn:true,//是否修改notion
				notioncodebtn:true,//第一次获取用户选择概念列表id
				citymapdata:[],//城市地图数据
				cityflag:false,//显示城市地图
				usernotionid:10,//用户选择id
				selectcitydata:[],//城市选择数据
				notionlist:[],//用户初始概念数据 
				notioncodelist:[],//用户初始概念数据id  
				usernotionlistsave:[],//用户选择的概念列表存储
				usernotionlist:[],//用户选择的概念列表
				usertaglist:[], 
				page: 1,  //显示的是哪一页
				haspage:true,//是否还有下一页
				pageSize: 10, //每一页显示的数据条数
				total: 0, //记录总数
				total1:0,
				totalPage:1,
				maxPage:10,  //最大页数
				provienceid:0,
				cityid:0,
				industryid:"",  
				enterpristlist:[],  
				num:1,
				testtoken:"-d8d2de4bc22ab997e946f42f9d49b79b", 
				websitetype:"产业招商大脑-智能推荐",
				curindex:1,
				userheadname:[
					{type:1,name:'龙头企业招商',curindex:2},
					{type:2,name:'同行业企业库',curindex:3},
					{type:3,name:'战略投资者',curindex:3},
					{type:4,name:'大型企业库',curindex:5},
					{type:5,name:'龙头企业合作',curindex:2},
					],
					searchtype:2,
					userdata:{},
					usernotionlistsave1:[],//用户默认概念数据
					searchtext:"",
					kwtextsearch:false,
					kwtextsearchtext:"",
					citydata:{},//城市数据
			}
		},
		//监听路由变化、newVal：目标路由，oldVal:原路由，路由不同时重新请求数据
		watch: {
				$route: function (newVal,oldVal) { 
					console.log('watch');
						console.log(this.$route.query.type);
						var ddst=0;
						if(this.$route.query.type){
							ddst=this.$route.query.type;
						} 
						this.searchtype=ddst; 
						var defaultlist=this.enterinarr.filter(list=>{
							return list.type == ddst;
						});
						this.typetoggle(defaultlist[0]);
						this.ajaxsearchcompany();
				}
		}, 
		beforeCreate() {
			this.bus.$emit('loading', true);
		},
		created() {  
			this.searchtype = this.$route.query.type;
				this.$nextTick(() => {
						// 禁用右键
						document.oncontextmenu = new Function("event.returnValue=false");
						// 禁用选择
						document.onselectstart = new Function("event.returnValue=false");
				}); 
				// this.searchtype = this.$route.query.type; 
		 var _this=this;  
			this.getuserinfor();    
			//用户概念数据
			this.$axios.get(this.$api.cyl.notion.list()+'?level=4',{headers:{AuthToken:this.userdata.token}}).then(function(res){ 
				console.log('用户概念数据',res.data.list)
				if(res.data.success){    
					var ddds=[];  
					_this.notionlist=res.data.list == null ? []:res.data.list;  
						// console.log('初始用户概念数据',_this.notionlist);
					_this.cityflag=true;
				}else{ 
					_this.tokenfailed(res.data.msg);
				} 
			}); 
		},
		mounted() { 
			document.getElementById('app').style.background = "#f0f3f5";
			var _this = this;
			var defaultlist={},
			defaultlist=this.enterinarr.filter(list=>{
				return list.type == _this.searchtype;
			})
			 // this.typetoggle(defaultlist[0]);
				this.ajaxsearchcompany();
		},
		methods: {  
			searchenter(e){
				if(e.keyCode == 13){
					this.searchkwfun();
				}
			},
			searchkwfun(){
				if(!this.userdata.token){
						this.isShowFreeUserTips = true;
						return;
					} 
				this.searchtext=$.trim(this.searchtext); 
				// if(this.searchtext!="" || ){
					// console.log(this.searchtext);
				this.ajaxsearchcompany();
				// } 
			},
			//导航栏筛选
			notionclickfun(arry){
				if(!this.userdata.token){
						this.isShowFreeUserTips = true;
						return;
					} 
				this.usernotionlist=arry;
				this.usernotionlistsave=arry; 
				this.usernotionid=arry[0].id;
				this.notioneditbtn=true;
				// console.log(arry);
				this.ajaxsearchcompany();
			},
			choosecityide(art){ 
				if(!this.userdata.token){
						this.isShowFreeUserTips = true;
						return;
					} 
				// console.log(art);
				this.choosecityid(art[0],art[1]);
			},
			chartmapclick:function(data){ 
				// console.log('地图数据',data); 
				var type="";
				if(data.data!=undefined && data.data.length>0){ 
					type=1;
				};
				this.choosecityid(data.id,type);
				// this.notionslide3=false; 
			}, 
			notionlistnumber(namelist,codelist){
				// console.log(namelist,codelist); 
				for(var i=0;i<namelist.length;i++){ 
				 let arry2=namelist[i].children;
					for(var d=0;d<namelist[i].children.length;d++){ 
						for(var s=0;s<codelist.length;s++){
							if(namelist[i].children[d].value  == codelist[s].code){
								namelist[i].children[d].count=codelist[s].count;
							}
						} 
						//二级
						// console.log('q',namelist[i].children[d].label);
						if(namelist[i].children[d].children!=null){
							for(var f=0;f<namelist[i].children[d].children.length;f++){
								for(var s=0;s<codelist.length;s++){
									if(namelist[i].children[d].children[f].value  == codelist[s].code){
										namelist[i].children[d].children[f].count=codelist[s].count;
									}
								}
								// console.log('f',namelist[i].children[d].children[f].label);
								if(namelist[i].children[d].children[f].children!=null){
										for(var g=0;g<namelist[i].children[d].children[f].children.length;g++){
											for(var s=0;s<codelist.length;s++){
												if(namelist[i].children[d].children[f].children[g].value  == codelist[s].code){
													namelist[i].children[d].children[f].children[g].count=codelist[s].count;
												}
											}
											// console.log('g',namelist[i].children[d].children[f].children[g].label); 
											//
										}  
								} 
								//
							}  
						}  
					 //
					} 
				};  
				this.notionlist=namelist;
			}, 
			//企业列表切换
			typetoggle(list) {
				console.log('企业列表切换',this.searchtyp != list.type);
				if (this.searchtyp != list.type) {
					this.searchtype = list.type;
					this.pagecode = list.pagecode;
					this.curindex = list.curindex;
					this.title=list.name;
					// document.title = '产业招商大脑-' + list.name;
			 this.ajaxsearchcompany();
				}
			}, 
			choosecityid(id,type){
				if(!this.userdata.token){
						this.isShowFreeUserTips = true;
						return;
					} 
				if(type == 1){
					this.provienceid=id;
					this.cityid=0;
				}else{
					this.provienceid=0;
					this.cityid=id;
				} 
				this.ajaxsearchcompany();
				this.notionslide1=false;
				this.notioneditbtn=false;
			}, 
			//公用部分
			getuserinfor(){
				this.userdata = this.getuseriformation();
				// this.industryid=this.userdata.industry; 
				this.usertaglist=this.taglistfun(this.userdata.tagText,this.userdata.tag);
				this.usernotionlistsave=this.taglistfun(this.userdata.notionText,this.userdata.notion);
				this.usernotionlistsave1=this.taglistfun(this.userdata.notionText,this.userdata.notion);
				var _this=this;
				this.userheadname.forEach((data)=>{
					if(data.type == _this.userdata.userType){
						_this.websitetype=data.name;
						_this.curindex=data.curindex; 
					} 
				})
				
			},  
			detailrouterto(path,id){
				this.routerlinkarry(path,{id:id}); 
			}, 
			pageHandler: function (page) {  
				this.notioneditbtn=false;
				this.ajaxsearchcompany(page); 
			},
			jsondouhao(name,data){ 
				if(data.length>0){ 
					var notionja="";
					if(data.length!=0){
						var douhao='%2C';
						for(var i=0;i<data.length;i++){ 
							if(i==data.length-1){
								douhao='';
							}
							notionja+=data[i].id+douhao;
						}
						notionja='&'+name+'='+notionja;
						return notionja;
					} 
				}else{
					return "";
				}
			},
			
			ajaxsearchcompany(pages){ 
			this.bus.$emit('loading',true);
			var ajpage=1;
			if(pages){
				ajpage=pages;
			}
			this.page=ajpage;
			var _this=this;
				//公司列表 type:1/2 area:provienceid industry行业id capital 注册资本 （暂无） 标签（暂无） chain相关产业链（暂无） page页码
				var indujson=''; 
				if(this.industryid != ""){
				indujson='&industry='+this.industryid;
				};  
				var tagaja=_this.jsondouhao('tag',this.usertaglist);   
				// console.log('usernotionseve',this.usernotionlistsave);
				var	notionja=_this.jsondouhao('notion',this.usernotionlistsave);
				if(this.usernotionlistsave.length<0){
					var notionja = _this.jsondouhao('notion',this.usernotionlistsave1);
				}
				if(this.userdata.token == _this.testtoken ){ //this.usernotionlistsave[0].id=='' 为了方便用户点击X删除已选概念
					notionja="";
				}
				console.log('serch',this.searchtype);
				if(this.searchtype==2||this.searchtype==3){
					var ajaxurl=this.$api.cyl.enterprise.list()+'?type='+this.searchtype+"&search=0"+this.splicing('city',this.cityid)+this.splicing('province',this.provienceid)+this.splicing('kw',this.searchtext)+notionja+tagaja+indujson+'&page='+ajpage;
				}else if(this.searchtype==6){
					var ajaxurl=this.$api.cyl.investorg.list()+'?page='+ajpage+this.splicing('province',this.provienceid)+this.splicing('city',this.cityid)+this.splicing('kw',this.searchtext)+notionja+tagaja+indujson;
				}else if(this.searchtype==7){
					var ajaxurl = this.$api.cyl.academy.list()+ '?page=' + ajpage+ '&city=' + this.splicing('province',this.provienceid)+this.splicing('city',this.cityid)+this.splicing('kw',this.searchtext)+notionja+tagaja+indujson;
				}
				// var ajaxurl=this.$api.cyl.enterprise.list()+'?type='+this.searchtype+'&city='+this.cityid+'&province='+this.provienceid+notionja+tagaja+indujson+'&kw='+this.searchtext+'&page='+ajpage;
				
				
				console.log(ajaxurl)
				this.$axios.get(ajaxurl,{headers:{AuthToken:this.userdata.token}}).then(function(res){
					console.log('leaden',res.data)  
					if(res.data.success){  
								_this.enterpristlist=res.data.list;
								// console.log(res.data.list[0])
								for(var i=0;i<res.data.list.length;i++){
									_this.enterpristlist[i].taglist=_this.taglistfun(_this.enterpristlist[i].tag,_this.enterpristlist[i].tagCode);
									_this.enterpristlist[i].notionlist=_this.taglistfun(_this.enterpristlist[i].notion,_this.enterpristlist[i].notionCode);
											//创新企业专属
											if(_this.enterpristlist[i].financingRound == null || _this.enterpristlist[i].financingRound.length == 0){
												_this.enterpristlist[i].financingRound=[];
											} 
								} 
									 
									_this.totalPage=res.data.totalPage;
									_this.pageSize=res.data.pageSize;  
									_this.total=res.data.totalRecord; 
									_this.haspage=res.data.list.length  == res.data.pageSize; 
									_this.kwtextsearch=	_this.searchtext!=''
									_this.kwtextsearchtext=_this.searchtext;
									//导航栏城市地图筛选
									// _this.cityscreen(res.data.cityList);
									var citylistd=[],citytest=res.data.cityList||[];
									for(var i=0;i<citytest.length;i++){
										let citylista ={}; 
										citylista.value=citytest[i].count;  
										citylista.id=citytest[i].id;  
										citylista.name=_this.citynameremove(citytest[i].name); 
										citylista.data=[];
										for(var p=0;p<citytest[i].children.length;p++){
											let citydtac={};
											citydtac.value=citytest[i].children[p].count;
											citydtac.id=citytest[i].children[p].id;
											citydtac.name=citytest[i].children[p].name;
											citylista.data.push(citydtac); 
										}
										citylistd.push(citylista); 
									}; 
									if(_this.notioneditbtn){
										_this.selectcitydata=citytest;
										_this.citymapdata=citylistd;
										_this.cityflag=true;
										_this.total1=res.data.totalRecord; 
									} 
									if(_this.notioncodebtn){
										// _this.notioncodebtn=false;
									// _this.notioncodelist=res.data.extend.notionList;
									 // _this.notionlistnumber(_this.notionlist,res.data.extend.notionList);
									} 
									_this.bus.$emit('loading',false);
					}else{ 
						_this.tokenfailed(res.data.msg);
					} 
				})
				// console.log(datas);  
			}
		}
	}
</script>

<style type="text/css" scoped="scoped">  
	.recommend-tips{
		color: #000;
		font-size: 14px;
	}
</style> 
